import React from 'react'
import {getLocalStorage} from "../../../utils/utils"
//TUTORIAL -> https://www.taniarascia.com/using-context-api-in-react/

function getLocalStorageToken(){
  return true
}

export const initialState = {
  isAuthenticated: getLocalStorage("tk") ? true : false,
  username: getLocalStorage("username") ? getLocalStorage("username") : "",
  first_name: getLocalStorage("first_name") ? getLocalStorage("first_name") : "",
  token:  getLocalStorage("tk") ? getLocalStorage("tk") : null,
  user: null,
};

// https://blog.liplex.de/axios-interceptor-to-refresh-jwt-token-after-expiration/

export const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("token", JSON.stringify(action.payload.token));
      return {
        ...state,
        isAuthenticated: true,
        user: localStorage.getItem("user"),
        token: localStorage.getItem("token"),
        user: null,
      };
      case "SET_PROFILE":
        return {
          ...state,
          user: action.payload
        }
    case "LOGOUT":
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token:null
      };
      
    default:
      return state;
  }
};

const AuthContext = React.createContext(initialState);

export const AuthProvider = AuthContext.Provider
export const AuthConsumer = AuthContext.Consumer
export default AuthContext